var makeString = require('./helper/makeString');

module.exports = function isBlank(str) {
  return (/^\s*$/).test(makeString(str));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/isBlank.js
// module id = 275
// module chunks = 0